function getAllContainers(selector) {
    const containers = [];
    const visitedRoots = new Set();
    const collectFromRoot = (root) => {
        if (visitedRoots.has(root))
            return;
        visitedRoots.add(root);
        containers.push(...Array.from(root.querySelectorAll(selector)).filter((el) => el instanceof HTMLElement));
        const shadowHosts = Array.from(root.querySelectorAll('*')).filter((el) => el instanceof HTMLElement && !!el.shadowRoot);
        shadowHosts.forEach(host => {
            if (host.shadowRoot) {
                collectFromRoot(host.shadowRoot);
            }
        });
    };
    collectFromRoot(document);
    return containers;
}
function getTilesFromShadow(container, tagName, tileSelector) {
    const slot = container.querySelector('slot');
    if (!slot)
        return [];
    const assigned = slot.assignedElements({ flatten: true });
    return assigned
        .map(el => {
        var _a;
        const cardElement = el.matches(tagName)
            ? el
            : el.querySelector(tagName);
        return ((_a = cardElement === null || cardElement === void 0 ? void 0 : cardElement.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector(tileSelector)) || null;
    })
        .filter((tile) => tile !== null);
}
function updateTileHeights(tiles) {
    tiles.forEach(originalTile => {
        const tile = originalTile;
        tile.style.height = 'auto';
        tile.style.maxHeight = 'none';
    });
    const maxHeight = Math.max(...tiles.map(tile => tile.clientHeight || 0));
    tiles.forEach(originalTile => {
        const tile = originalTile;
        tile.style.height = `${maxHeight}px`;
        tile.style.maxHeight = `${maxHeight}px`;
        tile.style.overflow = 'hidden';
    });
}

export { getAllContainers, getTilesFromShadow, updateTileHeights };
